import { render } from "./TargetData.vue?vue&type=template&id=c80ed00e"
import script from "./TargetData.vue?vue&type=script&lang=js"
export * from "./TargetData.vue?vue&type=script&lang=js"

import "./TargetData.vue?vue&type=style&index=0&id=c80ed00e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__